export default {
  props: {
    position: {
      show: String,
      default: 'bottom'
    },
    value: {
      type: Boolean,
      default: false
    },
    contentTitle: {
      type: String,
      default: null
    },
    lefyTitle: {
      type: String,
      default: null
    },
    isCloseIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      closeicon: require('@/assets/image/ic_xxxxxx.png')
    };
  },
  methods: {
    handleClose() {
      this.$emit('input', false);
      this.$emit('close');
    }
  }
};